/**
 * Valida si una cadena es un correo electrónico con formato válido.
 * @param {string} email - Dirección de correo electrónico a validar.
 * @returns {boolean} - Retorna true si el formato del correo es válido, de lo contrario false.
 */
export const isEmailValid = (email) => {
	const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
	return emailRegex.test(email);
};

/**
 * Verifica si un objeto tiene al menos una propiedad.
 * @param {Object} data - Objeto a evaluar.
 * @returns {boolean} - Retorna true si el objeto no está vacío, false si no tiene propiedades.
 */
export const isObjectEmpty = (data) => {
	return Object.keys(data).length !== 0;
};